import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext, useMemo, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../contexts/InfluencerContext'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import { SharedInfluencerContext } from '../../../../contexts/Advertiser/SharedInfluencerContext'
import Authentication from '../../../../models/Authentication'
import AgeDistribution from './StatisticsParts/AgeDistribution'
import Cities from './StatisticsParts/Cities'
import Countries from './StatisticsParts/Countries'
import Followers from './StatisticsParts/Followers'
import Gender from './StatisticsParts/Gender'
import StatisticBoxes from './StatisticsParts/StatisticBoxes'
import LikesComments from './StatisticsParts/LikesComments'
import TotalInteractions from './StatisticsParts/TotalInteractions'
import PostEngagements from './StatisticsParts/PostEngagements'
import Hashtags from './StatisticsParts/Hashtags'
import Mentions from './StatisticsParts/Mentions'
import axiosService from '../../../../utils/AxiosService'
import { toastError } from '../../../../components/FormComponents/Toasts'

export default observer(function Statistics() {
  const params = useParams()
  const { id, authentication_id, campaign_authentication_id } = params
  const influencerContext = useContext(InfluencerContext)
  const sharedCampaignContext = useContext(SharedCampaignContext)
  const sharedInfluencerContext = useContext(SharedInfluencerContext)
  const [authentications, setAuthentications] = useState([])

  const isAdvertiserContext = !!sharedCampaignContext?.campaignState
  const isInfluencerShareContext = !!sharedInfluencerContext?.influencerState
  const currentId = isInfluencerShareContext
    ? (sharedInfluencerContext?.authentications?.[0]?.id)
    : (isAdvertiserContext ? authentication_id : id)

  useEffect(() => {
    if (isAdvertiserContext && authentication_id) {
      axiosService.get(`/api/advertiser/campaign_share/authentications/${authentication_id}/authentications`)
        .then(authentications => {
          const mappedAuthentications = authentications.map(authentication => new Authentication(authentication))
          setAuthentications(mappedAuthentications)
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.error || error?.data?.error || error?.error || error?.message || 'An error occurred'
          toastError(errorMessage)
        })
    }
  }, [isAdvertiserContext, authentication_id])

  const pmAuthentications = influencerContext?.authentications || []
  const sharedInfluencerAuthentications = sharedInfluencerContext?.authentications || []
  const currentAuthentications = isInfluencerShareContext
    ? sharedInfluencerAuthentications
    : (isAdvertiserContext ? authentications : pmAuthentications)

  const currentAuthentication = useMemo(() => currentAuthentications.find(authentication => +authentication.id === +currentId ) || new Authentication(), [currentId, currentAuthentications, currentAuthentications.length] )

  return (
    <div className="grid grid-cols-1 gap-4 bg-rb-grey dark:bg-rb-dark-mode-background">
      <div className="grid grid-cols-5 gap-4">
        <StatisticBoxes  currentAuthentication={currentAuthentication} />
      </div>
      <div className="grid grid-cols-4 gap-4">
        <Gender currentAuthentication={currentAuthentication} />
        <AgeDistribution currentAuthentication={currentAuthentication} />
        <Countries currentAuthentication={currentAuthentication} />
        <Cities currentAuthentication={currentAuthentication} />
        <LikesComments currentAuthentication={currentAuthentication} />
        <TotalInteractions currentAuthentication={currentAuthentication} />
        <Followers currentAuthentication={currentAuthentication} />
        {currentAuthentication.provider === 'instagram' &&
          <Fragment>
            <Hashtags currentAuthentication={currentAuthentication} />
            <Mentions currentAuthentication={currentAuthentication} />
          </Fragment>
        }
        <PostEngagements currentAuthentication={currentAuthentication} />
      </div>
    </div>
  )
})
